/**
 * <image-carousel> — manual horizontal carousel.
 * Native scroll-snap for touch/trackpad, mouse drag-to-scroll, and prev/next buttons.
 */
if (!customElements.get('image-carousel')) {
  customElements.define(
    'image-carousel',
    class ImageCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollBySlide(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollBySlide(1));

        this.setupDrag();
      }

      slideStep() {
        const slide = this.track.querySelector('.img-carousel__slide');
        if (!slide) return this.track.clientWidth;
        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      scrollBySlide(direction) {
        this.track.scrollBy({ left: direction * this.slideStep(), behavior: 'smooth' });
      }

      setupDrag() {
        let dragging = false;
        let startX = 0;
        let startLeft = 0;

        this.track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') return; // let touch use native scroll
          dragging = true;
          startX = event.clientX;
          startLeft = this.track.scrollLeft;
          this.track.setPointerCapture(event.pointerId);
          this.track.classList.add('is-dragging');
        });

        this.track.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          this.track.scrollLeft = startLeft - (event.clientX - startX);
        });

        const end = () => {
          dragging = false;
          this.track.classList.remove('is-dragging');
        };
        this.track.addEventListener('pointerup', end);
        this.track.addEventListener('pointercancel', end);
      }
    }
  );
}
